<a
  class="mx-4 grid cursor-pointer items-center justify-center gap-1 border-none bg-transparent text-white no-underline focus-link hover:underline lg:grid-cols-2"
  [attr.aria-label]="
    getAriaLabel(itemCount) | translate: { itemCount: itemCount }
  "
  [routerLink]="['/shopping-cart']">
  <span class="relative inline-block">
    <rd-shared-icon
      class="my-4 flex h-6 w-6"
      [iconSymbol]="'icon-cart'"></rd-shared-icon>
    <span
      *ngIf="itemCount > 0"
      class="cart-badge absolute top-2.5 -right-2 min-h-[16px] min-w-[16px] whitespace-nowrap rounded-full bg-[#df7a00] px-0.5 text-center text-sm leading-4 lg:-right-1.5"
      [ngClass]="{ 'px-1.5': itemCount > 9 }">
      {{ formatItemCount(itemCount) }}
    </span>
  </span>
  <p class="my-4 hidden text-base text-white lg:block">Cart</p>
</a>
